import { createContext, Dispatch } from 'react'

export interface NavigationBreadcrumb {
  title: string
  link: string
}

interface BreadcrumbsContextProps {
  breadcrumbs: NavigationBreadcrumb[]
  dispatchBreadcrumbs: Dispatch<{
    type: 'add' | 'remove'
    value: NavigationBreadcrumb
  }>
}

export const BreadcrumbsContext = createContext<BreadcrumbsContextProps>({
  breadcrumbs: [],
  dispatchBreadcrumbs: () => {},
})

BreadcrumbsContext.displayName = 'BreadcrumbsContext'
